import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';
import { PaginationListResponse } from 'src/app/_models/pagination-list-response';
import { environment } from 'src/environments/environment';
import { GetOfertasTrabajoDetalleResponse } from '../../egresado/responses/get-detalles-oferta-egr-response';
import { DeleteOfertaTrabajoActivaRequest } from '../../empresa/requests/delete-oferta-activa-request';
import { UpdateEstadoPostulacionRequest } from '../../empresa/requests/update-estado-postulacion-request';
import { DeleteOfertaTrabajoActivaResponse } from '../../empresa/responses/delete-oferta-activa-response';
import { GetEmpresaDetallesPostuladoResponse } from '../../empresa/responses/get-detalles-postulante-response';
import { PostEmpresaImageResponse } from '../../empresa/responses/get-imagepath-response';
import { UpdateEstadoPostulacionResponse } from '../../empresa/responses/update-estado-postulacion-response';
import { GetDetallesOfertaRequest } from '../requests/get-detalles-oferta-request';
import { GetHistorialOfertasDocenteRequest } from '../requests/get-historial-ofertas-docente-request';
import { GetOfertasActivasDocenteRequest } from '../requests/get-ofertas-activas-docente-request';
import { GetOfertasRevisionDocenteRequest } from '../requests/get-ofertas-revision-docente-request';
import { InsertDocenteRequest } from '../requests/insert-docente-request';
import { InsertOfertaTrabajoExternaRequest } from '../requests/insert-oferta-trabajo-externa-request';
import { UpdatePasswordDocenteRequest } from '../requests/update-password-docente-request';
import { GetHistorialOfertasDocenteResponse } from '../responses/get-historial-ofertas-docente-response';
import { GetOfertasActivasDocenteResponse } from '../responses/get-ofertas-activas-docente-response';
import { GetOfertasRevisionDocenteResponse } from '../responses/get-ofertas-revision-docente-response';
import { InsertDocenteResponse } from '../responses/insert-docente-response';
import { InsertOfertaTrabajoExternaResponse } from '../responses/insert-oferta-trabajo-externa-response';
import { UpdatePasswordDocenteResponse } from '../responses/update-password-docente-response';

@Injectable({
  providedIn: 'root'
})
export class DocenteService implements OnDestroy{
  private destroy$: Subject<void> = new Subject<void>();

  controller = 'CuentaDocente';
  constructor(private _http: HttpClient) {}
  

  insertDocente(request:InsertDocenteRequest): Observable<InsertDocenteResponse> {
    return this._http.post<InsertDocenteResponse>(
      `${environment.url_api}${this.controller}/add-docente`,request
    );
  }

  getHistorialOfertas(request: number): Observable<PaginationListResponse<GetHistorialOfertasDocenteResponse>> {
    let parameters = { idUsuarioDocente : request};
    return this._http.get<PaginationListResponse<GetHistorialOfertasDocenteResponse>>(
      `${environment.url_api}${this.controller}/list-historial-ofertas-docente`,
      {params:parameters}
    ).pipe(takeUntil(this.destroy$));
  }

  getHistorialOfertasByPage(request: number,page): Observable<PaginationListResponse<GetHistorialOfertasDocenteResponse>> {
    let parameters = { idUsuarioDocente : request,'skip':page.toString()};
    return this._http.get<PaginationListResponse<GetHistorialOfertasDocenteResponse>>(
      `${environment.url_api}${this.controller}/list-historial-ofertas-docente`,
      {params:parameters}
    ).pipe(takeUntil(this.destroy$));
  }
  
  getOfertasRevision(request: number): Observable<PaginationListResponse<GetOfertasRevisionDocenteResponse>> {
    let parameters = { idUsuarioDocente : request};
    return this._http.get<PaginationListResponse<GetOfertasRevisionDocenteResponse>>(
      `${environment.url_api}${this.controller}/list-ofertas-revision-docente`,
      {params:parameters}
    ).pipe(takeUntil(this.destroy$));
  }

  getOfertasRevisionByPage(request: number,page): Observable<PaginationListResponse<GetOfertasRevisionDocenteResponse>> {
    let parameters = { idUsuarioDocente : request,'skip':page.toString()};
    return this._http.get<PaginationListResponse<GetOfertasRevisionDocenteResponse>>(
      `${environment.url_api}${this.controller}/list-ofertas-revision-docente`,
      {params:parameters}
    ).pipe(takeUntil(this.destroy$));
  }

  getOfertasActivas(request: number): Observable<PaginationListResponse<GetOfertasActivasDocenteResponse>> {
    let parameters = { idUsuarioDocente : request};
    return this._http.get<PaginationListResponse<GetOfertasActivasDocenteResponse>>(
      `${environment.url_api}${this.controller}/list-ofertas-activas-docente`,
      {params:parameters}
    ).pipe(takeUntil(this.destroy$));
  }

  getOfertasActivasByPage(request: number,page): Observable<PaginationListResponse<GetOfertasActivasDocenteResponse>> {
    let parameters = { idUsuarioDocente : request,'skip':page.toString()};
    return this._http.get<PaginationListResponse<GetOfertasActivasDocenteResponse>>(
      `${environment.url_api}${this.controller}/list-ofertas-activas-docente`,
      {params:parameters}
    ).pipe(takeUntil(this.destroy$));
  }

  getDetallesOferta(request: number): Observable<GetOfertasTrabajoDetalleResponse> {
    let parameters = { idOferta : request};
    return this._http.get<GetOfertasTrabajoDetalleResponse>(
      `${environment.url_api}${this.controller}/obtener-detalles-oferta`,
      {params:parameters}
    ).pipe(takeUntil(this.destroy$));
  }

  updatePassword(request: UpdatePasswordDocenteRequest): Observable<UpdatePasswordDocenteResponse> {
    return this._http.put<UpdatePasswordDocenteResponse>(
      `${environment.url_api}${this.controller}/update-password`, 
      request).pipe(takeUntil(this.destroy$));;
  }

  deleteOfertaActiva(idOferta: number): Observable<DeleteOfertaTrabajoActivaResponse> {
    let request = {} as DeleteOfertaTrabajoActivaRequest;
      request.idOferta=idOferta;
    return this._http.put<DeleteOfertaTrabajoActivaResponse>(
      `${environment.url_api}${this.controller}/borrar-oferta-activa`,
      request
    ).pipe(takeUntil(this.destroy$));
  }

  insertOfertaTrabajoExterna(request:InsertOfertaTrabajoExternaRequest): Observable<InsertOfertaTrabajoExternaResponse> {
    return this._http.post<InsertOfertaTrabajoExternaResponse>(
      `${environment.url_api}${this.controller}/crear-oferta`,request
    ).pipe(takeUntil(this.destroy$));
  }

  updateEstadoPostulacion(request: UpdateEstadoPostulacionRequest): Observable<UpdateEstadoPostulacionResponse> {
    return this._http.put<UpdateEstadoPostulacionResponse>(
      `${environment.url_api}${this.controller}/actualizar-estado-postulacion`, 
      request
    ).pipe(takeUntil(this.destroy$));
  }

  getDetallesPostulante(idUsuario: number): Observable<GetEmpresaDetallesPostuladoResponse> {
    let parameters = { idUsuario : idUsuario};
    return this._http.get<GetEmpresaDetallesPostuladoResponse>(
      `${environment.url_api}${this.controller}/obtener-detalles-postulado`,
      {params:parameters}
    ).pipe(takeUntil(this.destroy$));
  } 

  subirFotografiaDetalle(archivo: File): Observable<PostEmpresaImageResponse> {
    let formData = new FormData();
    formData.append('formFile', archivo, archivo.name);
  
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
  
    let options = { headers: headers};
  
    return this._http.post<PostEmpresaImageResponse>(
      `${environment.url_api}${this.controller}/upload-detalle-image`,
      formData,
      options
    ).pipe(takeUntil(this.destroy$));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
